import * as actions from './actions';

const ElasticSearchPermitCache = {
  actions
};

export default ElasticSearchPermitCache;
